import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e7ef524"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = { class: "campaign-action-connected" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "campaign-action-allowlist-info" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["data-network"]
const _hoisted_9 = ["data-network", "data-override-connect-text"]

import {
  ArrowTopRightOnSquareIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/vue/20/solid';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectWallet',
  setup(__props) {

const store = useClaimStore();
// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');
const expanded = ref(false);

const allowlistRequirement = computed(() => {
  console.log('networkId', store.networkId);
  return store.flatRequirements.find((requirement) => requirement.type === 'allowlist');
});

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onMounted(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).isLoggedIn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "campaign-action-connected-button",
            onClick: () => (expanded.value = !expanded.value)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(CheckIcon), { class: "icon-complete" }),
              _createElementVNode("span", null, _toDisplayString(_unref(store).ensOrFormattedWalletAddress), 1)
            ]),
            (expanded.value)
              ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                  key: 0,
                  class: "icon-down"
                }))
              : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                  key: 1,
                  class: "icon-down"
                }))
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createTextVNode(" Allowlist:  "),
        (!!_unref(store).allowlistLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(store).allowlistLink,
              target: "_blank"
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(store).allowlistDescription || 'Allowlist') + " ", 1),
              _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "icon-link" })
            ], 8, _hoisted_6))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(store).allowlistDescription || 'Allowlist'), 1))
      ], 512), [
        [_vShow, expanded.value && !!allowlistRequirement.value]
      ]),
      (_unref(store).isLoggedIn)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "giveaway-disconnect",
            "data-widget": "m-connect",
            "data-grant-type": "signature",
            "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
            "data-app-name": "Manifold Notifications",
            "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
            "data-enable-network-switching": true,
            "data-network": _unref(store).networkId,
            "data-browser-provider-ignore-disconnect": true,
            "data-multi": "true",
            "data-override-connect-text": "Connect wallet to get started",
            "data-message": "Please sign this message to use this Manifold Giveaway page and allow us to check for your eligibility."
          }, null, 8, _hoisted_8)), [
            [_vShow, expanded.value]
          ])
        : _createCommentVNode("", true)
    ]),
    (!_unref(store).isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "giveaway-connect",
          "data-disabled": "true",
          "data-widget": "m-connect",
          "data-grant-type": "signature",
          "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
          "data-app-name": "Manifold Notifications",
          "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
          "data-enable-network-switching": true,
          "data-network": _unref(store).networkId,
          "data-browser-provider-ignore-disconnect": true,
          "data-multi": "true",
          "data-override-connect-text": 
        _unref(store).allowlistRequirement ? 'Check eligibility' : 'Connect wallet to get started'
      ,
          "data-message": "Please sign this message to use this Manifold Giveaway page and allow us to check for your eligibility."
        }, null, 8, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}
}

})